import React, {useState} from 'react';
import {Col, Container, Row, Form} from 'react-bootstrap';
import {selectSubscriptionText} from '../selectSubscriptionText';
import {
  subAiIcon,
  subscriptionGreenCheck,
  subStorageIc,
  subUsersIc,
} from '../../../../assets/images';
import {fixSubscriptionIdForAnnual} from '../../config';

interface Props {
  plan: any;
  onSelect: (tier?: number) => void;
}

const SubscriptionDetails = React.memo(({plan, onSelect}: Props) => {
  const planName = plan.title?.toLowerCase();

  const [billing, setBilling] = useState<'monthly' | 'annual'>('annual');

  const perYearLabel = ' / year';
  const perMonthLabel = ' / month';

  const monthlyPrice = plan.pricePerMonth;
  const annualPrice = plan.pricePerYear;

  // Solo Creator o Business
  const showToggle = planName === 'creator' || planName === 'business';

  return (
    <Container>
      <Row>
        <Col lg={{span: 10, offset: 1}} xs={12}>
          {/* Toggle mensual/anual */}
          <div
            className="d-flex align-items-center gap-3 mb-3 price-time-toggle"
            style={{
              opacity: showToggle ? 1 : 0,
              pointerEvents: showToggle ? 'auto' : 'none',
            }}>
            <span className={billing === 'monthly' ? 'fw-semibold' : ''}>
              Monthly
            </span>
            <Form.Check
              type="switch"
              id="billing-toggle"
              checked={billing === 'annual'}
              onChange={() =>
                setBilling(b => (b === 'annual' ? 'monthly' : 'annual'))
              }
              aria-label="Toggle billing period"
            />
            <span className={billing === 'annual' ? 'fw-semibold' : ''}>
              Annual
            </span>
          </div>

          <Row className="SubscriptionDetailsContainer">
            <Col xs={12} className="Header">
              <p className="SelectSubtitle">{plan.header}</p>
            </Col>

            <Col md={7} lg={6} xs={12} style={{padding: 0}}>
              <div className="PriceContainer">
                <h3>{plan.title}</h3>

                {/* Precio dinámico */}
                {billing === 'annual' ? (
                  <span className="PerYear">
                    <h2 className="YearPrice">{annualPrice}</h2>
                    {!['trial', 'enterprise'].includes(planName) &&
                      perYearLabel}
                  </span>
                ) : (
                  <span className="PerMonth">
                    <h2 className="MonthPrice">{monthlyPrice}</h2>
                    {!['trial', 'enterprise'].includes(planName) &&
                      perMonthLabel}
                  </span>
                )}
              </div>

              <div className="FeaturesContainer d-block d-md-none">
                <h6>{selectSubscriptionText.features}</h6>
                <div>
                  {plan.features.map((feature: string) => (
                    <div key={feature} className="FeatureItem">
                      <img src={subscriptionGreenCheck} />
                      {feature}
                    </div>
                  ))}
                </div>
              </div>

              <div className="ResourcesContainer">
                <p>{selectSubscriptionText.whatIsIncluded}</p>
                <div className="ResourceContainer">
                  <img src={subAiIcon} />
                  <span>
                    {billing === 'annual'
                      ? plan.aiCreditsPerYear
                      : plan.aiCreditsPerMonth}
                  </span>
                </div>
                <div className="ResourceContainer">
                  <img src={subStorageIc} />
                  <span>{plan.storage}</span>
                </div>
                <div className="ResourceContainer">
                  <img src={subUsersIc} />
                  <span>{plan.amountOfUsers}</span>
                </div>
              </div>

              <div className="AddUsersContainer">
                <button
                  className="SignupButton"
                  onClick={() => {
                    if (plan.title.toLowerCase() === 'enterprise') {
                      window.open(
                        'https://tapybl.com/request-quote/',
                        '_blank',
                      );
                    } else {
                      onSelect(
                        fixSubscriptionIdForAnnual(
                          plan.id,
                          billing === 'annual',
                        ),
                      );
                    }
                  }}>
                  {plan.buttonText}
                </button>
                {planName !== 'trial' && (
                  <button
                    className="TrialButton"
                    onClick={() => onSelect(plan.trialTier)}>
                    {plan.trialText}
                  </button>
                )}
              </div>
            </Col>

            <Col
              md={5}
              lg={6}
              xs={12}
              className="FeaturesContainer d-none d-md-block">
              <h6>{selectSubscriptionText.features}</h6>
              <div>
                {plan.features.map((feature: string) => (
                  <div key={feature} className="FeatureItem">
                    <img src={subscriptionGreenCheck} />
                    {feature}
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
});

export default SubscriptionDetails;
